import { memo, useLayoutEffect } from 'react';
import { gsap, Power1 } from 'gsap';
import { DrawSVGPlugin } from 'gsap/dist/DrawSVGPlugin';
import PropTypes from 'prop-types';

gsap.registerPlugin(DrawSVGPlugin);

const LineAnimation = ({
	lineId,
	children,
	drawSVG = '0% 0%',
	duration,
	delay,
	ease = Power1.easeIn,
}) => {
	const ctx = gsap.context(() => {});

	useLayoutEffect(() => {
		ctx.add(() => {
			if (delay) {
				gsap.set(lineId, { autoAlpha: 0 });
				gsap.set(lineId, { autoAlpha: 1, delay });
			}
			gsap.from(lineId, { delay, duration, drawSVG, ease });
		});
		return () => ctx.revert();
	}, []);

	return <>{children}</>;
};

LineAnimation.propTypes = {
	lineId: PropTypes.string,
	children: PropTypes.node,
};

export default memo(LineAnimation);
